/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitebusinessinfo2Inputs */

const en_invitebusinessinfo2 = /** @type {(inputs: Invitebusinessinfo2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The business owner will receive an email with instructions to verify their email address and set a password.`)
};

const de_invitebusinessinfo2 = /** @type {(inputs: Invitebusinessinfo2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Geschäftsinhaber erhält eine E-Mail mit Anweisungen zur Bestätigung seiner E-Mail-Adresse und zum Festlegen eines Passworts.`)
};

/**
* | output |
* | --- |
* | "The business owner will receive an email with instructions to verify their email address and set a password." |
*
* @param {Invitebusinessinfo2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invitebusinessinfo2 = /** @type {((inputs?: Invitebusinessinfo2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitebusinessinfo2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invitebusinessinfo2(inputs)
	return de_invitebusinessinfo2(inputs)
});
export { invitebusinessinfo2 as "inviteBusinessInfo" }